﻿import * as React from 'react';
import { connect } from 'react-redux';
import Loader from 'react-loader';
import moment from 'moment';
import { withRouter } from 'react-router-dom';
import { FormGroup, ControlLabel, Col, Row } from 'react-bootstrap';
import DateTime from 'react-datetime';
import { Translate } from '../../../shared/LanguageService';
import { handleError } from '../../../shared/ErrorCatching';
import FormSelect from '../../../components/common/FormSelect';
import * as actions from '../OrdersActions';
import { IFilmOrderListItem } from '../Entities';
import FormInputChangeHandler from '../../../shared/form/FormInputChangeHandler';
import FilmOrderList from './FilmOrderList';
import {
    filterByFilmType,
    FilmTypeAll,
    FilmTypeRegular,
    FilmTypeSoMeFilm
} from './filmTypeFilter';
import { filterByFilmStatus } from './filmStatusFilter';
import { assign } from '../../../shared/Assign';

const LIST_UPDATE_INTERVAL_MS: number = 600000;

class FilmOrdersPage extends React.Component<any, any> {
    formInputChangeHandler: FormInputChangeHandler;
    private pollingTimer: number;

    constructor(props: any, context: any) {
        super(props, context);
        this.state = {
            orders: [],
            filters: {
                region: -1,
                orderStatus: -1,
                filmType: FilmTypeAll,
                endDate: moment(new Date())
            },
            isLoading: false
        };

        this.getFilmOrders = this.getFilmOrders.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.setValue = this.setValue.bind(this);
        this.onDateTimeChange = this.onDateTimeChange.bind(this);

        this.formInputChangeHandler = new FormInputChangeHandler(this.state.filters, this.setValue);
    }

    setValue(newState: any) {
        this.setState({ filters: newState });
    }

    componentDidMount() {
        this.pollForOrders().catch(handleError);
    }

    componentWillUnmount() {
        clearTimeout(this.pollingTimer);
    }
    
    pollForOrders = async (): Promise<void> => {
        try {
            await this.getFilmOrders();
            clearTimeout(this.pollingTimer);
            this.pollingTimer = window.setTimeout(this.pollForOrders, LIST_UPDATE_INTERVAL_MS);
        } catch (error) {
            throw error;
        }
          
    }

    getFilmOrders() {
        if (!this.state.isLoading) {
            let date = moment(this.state.filters.endDate);
            this.setState({ isLoading: true });
            this.props.actions
                .getOrders(date.year(), date.month() + 1, date.date())
                .then(() => {
                    this.setState({ isLoading: false });
                })
                .catch((error: any) => {
                    this.setState({ isLoading: false });
                    return handleError(error);
                });
        }
    }

    onDateTimeChange(moment: any): void {
        let filters = this.state.filters;
        filters.endDate = moment;

        this.setState({ filters: assign({}, filters) }, this.getFilmOrders);
    }

    render() {
        let orders: IFilmOrderListItem[] = [];
        if (this.props.orders) {
            orders = this.props.orders;
        }

        let filters = this.state.filters;

        if (filters.region !== -1) {
            orders = orders.filter((x) => x.regionId.toString() === filters.region.toString());
        }

        orders = filterByFilmStatus(orders, filters.orderStatus);

        orders = filterByFilmType(orders, filters.filmType);

        return (
            <div>
                <Row>
                    <h1>
                        {Translate('orders/title/films')}{' '}
                        {!this.state.isLoading && (
                            <span className="number-of-orders">({orders.length})</span>
                        )}
                    </h1>
                </Row>
                <Row>
                    <Col md={3}>
                        <FormGroup className="no-margin">
                            <ControlLabel>{Translate('orders/list/film/header/date')}</ControlLabel>
                            <DateTime
                                locale={moment.locale()}
                                timeFormat={false}
                                onChange={this.onDateTimeChange}
                                value={filters.endDate}
                                closeOnSelect={true}
                            />
                        </FormGroup>
                    </Col>
                    <Col md={3}>
                        <FormGroup>
                            <ControlLabel>
                                {Translate('orders/list/film/header/status')}
                            </ControlLabel>
                            <FormSelect
                                name="orderStatus"
                                data-testid="filter-orderStatus"
                                value={this.state.filters.orderStatus}
                                onChange={this.formInputChangeHandler.onChange}
                            >
                                <option value="-1">
                                    {Translate('products/page/select-label/filter')}
                                </option>
                                {this.props.orderStatuses &&
                                    this.props.orderStatuses.map((t: any) => {
                                        return (
                                            <option key={t.id} value={t.id}>
                                                {Translate(t.name)}
                                            </option>
                                        );
                                    })}
                            </FormSelect>
                        </FormGroup>
                    </Col>
                    <Col md={3}>
                        <FormGroup>
                            <ControlLabel>
                                {Translate('orders/list/film/header/regions')}
                            </ControlLabel>
                            <FormSelect
                                name="region"
                                data-testid="filter-region"
                                value={this.state.filters.region}
                                onChange={this.formInputChangeHandler.onChange}
                            >
                                <option value="-1">
                                    {Translate('products/page/select-label/filter')}
                                </option>
                                {this.props.regions &&
                                    this.props.regions.map((t: any) => {
                                        return (
                                            <option key={t.id} value={t.id}>
                                                {t.name}
                                            </option>
                                        );
                                    })}
                            </FormSelect>
                        </FormGroup>
                    </Col>
                    <Col md={3}>
                        <FormGroup>
                            <ControlLabel>
                                {Translate('orders/list/film/header/film-type')}
                            </ControlLabel>
                            <FormSelect
                                name="filmType"
                                data-testid="filter-filmType"
                                value={this.state.filters.filmType}
                                onChange={this.formInputChangeHandler.onChange}
                            >
                                <option value={FilmTypeAll}>
                                    {Translate('products/page/select-label/filter')}
                                </option>
                                <option value={FilmTypeRegular}>
                                    {Translate('product-property/film')}
                                </option>
                                <option value={FilmTypeSoMeFilm}>
                                    {Translate('product-property/some-film')}
                                </option>
                            </FormSelect>
                        </FormGroup>
                    </Col>
                </Row>
                <Loader loaded={!this.state.isLoading}>
                    <FilmOrderList orders={orders} user={this.props.user} />
                </Loader>
            </div>
        );
    }

    closeModal() {
        this.setState({ showModal: false, selectedOrderId: null });
    }
}

function mapStateToProps(state: any, ownProps: any) {
    return {
        orders: state.orders.filmOrders.list,
        orderStatuses: state.orders.filmOrders.orderStatuses,
        regions: state.orders.filmOrders.regions,
        user: state.user
    };
}

function mapDispatchToProps(dispatch: any) {
    return {
        actions: {
            getOrders: (year: number, month: number, day: number) =>
                dispatch(actions.getFilmOrders(year, month, day))
        }
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(FilmOrdersPage));
